// src/plugins/jquery-setup.js
import $ from 'jquery';

// 1. Expose jQuery to window (critical for legacy libraries like jquery-ui)
window.jQuery = $;
window.$ = $;

// DEBUG: Check if event system is healthy
if (!$.event) {
    $.event = { global: {} };
} else if (!$.event.global) {
    // This fixes the specific error: "Cannot set properties of undefined (setting 'mouseup')"
    // caused by $.event.global being undefined in some bundler configurations
    $.event.global = {};
}

// 2. Setup custom event handlers (copied from main.js)
// These must be defined before UI libraries might try to use them or after jQuery is ready.
// Putting them here defines them on the jQuery instance immediately.

$.event.special.touchstart = {
    setup: function( _, ns, handle ){
        if ( ns.includes("noPreventDefault") ) {
            this.addEventListener("touchstart", handle, { passive: false });
        } else {
            this.addEventListener("touchstart", handle, { passive: true });
        }
    }
};
$.event.special.touchend = {
    setup: function( _, ns, handle ){
        if ( ns.includes("noPreventDefault") ) {
            this.addEventListener("touchend", handle, { passive: false });
        } else {
            this.addEventListener("touchend", handle, { passive: true });
        }
    }
};
$.event.special.touchmove = {
    setup: function( _, ns, handle ){
        if ( ns.includes("noPreventDefault") ) {
            this.addEventListener("touchmove", handle, { passive: false });
        } else {
            this.addEventListener("touchmove", handle, { passive: true });
        }
    }
};
$.event.special.touchcancel = {
    setup: function( _, ns, handle ){
        if ( ns.includes("noPreventDefault") ) {
            this.addEventListener("touchcancel", handle, { passive: false });
        } else {
            this.addEventListener("touchcancel", handle, { passive: true });
        }
    }
};
$.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        if ( ns.includes("noPreventDefault") ) {
            this.addEventListener("mousewheel", handle, { passive: false });
        } else {
            this.addEventListener("mousewheel", handle, { passive: false });
        }
    }
};

export default $;
